module.exports = __webpack_public_path__ + "images/fa856ada58bae9923c1e5cf47afd088d60f1f4653898b9f16e7fe3d99ddb37e3.svg";